const regexes = {
  EMAIL: /.+\@.+\..+/,
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[?()!@#$%^&*.<>:+\-,{_}=+`[\];/\s'´\\|~"])(?=.{8,})/,
  UUID: /([a-z\d]{8}(-[a-z\d]{4}){3}-[a-z\d]{12}?)/i,
  LETTERS_ONLY: /^[\p{Letter}][^\p{Emoji_Presentation}]*$/gu,
  NO_EMOJIS: /^[^\p{Emoji_Presentation}]*$/gu,
  ADDRESS: {
    ETH: /^0x[a-fA-F0-9]{40}$/g,
    BTC: /^(bc1|[13]|tb1|[mn2])[a-zA-Z0-9]{25,42}$/g,
    ERD: /^erd1[a-z0-9]{58}$/g,
  },
};

export default regexes;
